import { EnableGuestWebResult as EnableGuestWebResultDto } from 'gleblu-socket-api';

import EnableGuestWebResult from '../interfaces/EnableGuestWebResult';

export function fromDto(dto: EnableGuestWebResultDto): EnableGuestWebResult {
  return EnableGuestWebResult[dto];
}

export function toDto(_: EnableGuestWebResult): EnableGuestWebResultDto {
  throw new Error('Not supported');
}
